<template>
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="个人中心" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/supplierIndex" slot="left">
        <yd-navbar-back-icon></yd-navbar-back-icon>
      </router-link>
      <router-link to="/supplierEdit" slot="right">
        编辑
      </router-link>
    </yd-navbar>
    <yd-flexbox>
      <yd-flexbox-item>
        <yd-preview :buttons="btns" class="nobtn">
          <yd-lightbox>
            <img src="../assets/img/supplier_name.png" style="width:80px;heiht:80px;"><br>
            <span class="user-name">{{userInfo.user_name}}</span>
          </yd-lightbox>
          <yd-preview-header>

            <div slot="left" style="color:#000">状态</div>
            <div slot="right">
              <yd-badge shape="square" type="primary">{{userInfo.status}}</yd-badge>
            </div>
          </yd-preview-header>
          <yd-preview-item>
            <div slot="left">供应商编码</div>
            <div slot="right">{{userInfo.supplier_no}}</div>
          </yd-preview-item>
          <yd-preview-item>
            <div slot="left">供应商名称</div>
            <div slot="right">{{userInfo.supplier_name}}</div>
          </yd-preview-item>
          <yd-preview-item>
            <div slot="left">手机号</div>
            <div slot="right">{{userInfo.user_phone}}</div>
          </yd-preview-item>
<!--          <yd-preview-item>-->
<!--            <div slot="left">授权截止日期</div>-->
<!--            <div slot="right">{{userInfo.grant_date}}</div>-->
<!--          </yd-preview-item>-->
          <yd-preview-item>
            <div slot="left">注册时间</div>
            <div slot="right">{{userInfo.create_date}}</div>
          </yd-preview-item>
<!--          <yd-preview-item>-->
<!--            <div slot="left">授权委托书</div>-->
<!--            <div slot="right">-->
<!--&lt;!&ndash;              <yd-button type="hollow" size="mini">查看</yd-button>&ndash;&gt;-->
<!--              <yd-button type="hollow" size="mini" @click.native="updateGrant">更新</yd-button>-->
<!--            </div>-->
<!--          </yd-preview-item>-->
          <yd-preview-item style="display: none">
            <div slot="left">手写签名</div>
            <div slot="right"><yd-button type="hollow" size="mini">查看</yd-button></div>
          </yd-preview-item>
          <yd-preview-item @click.native="myContract">
            <div slot="left">我的合同</div>
            <div slot="right">
              <yd-navbar-next-icon></yd-navbar-next-icon>
            </div>
          </yd-preview-item>
          <yd-preview-item @click.native="myApprove">
            <div slot="left">我的消息</div>
            <div slot="right">
              <span style="color: #dc4d4d">{{unreadNum}}</span><yd-navbar-next-icon></yd-navbar-next-icon>
            </div>
          </yd-preview-item>
        </yd-preview>
        <yd-button size="large" type="hollow" style="border: #2f6fff 1px solid;" shape="circle" @click.native="updPsw">修改密码</yd-button>
        <yd-button size="large" type="hollow" style="border: #2f6fff 1px solid;" shape="circle" @click.native="logout">退出登录</yd-button>
      </yd-flexbox-item>
    </yd-flexbox>

    <yd-tabbar class="tabbar-footer" active-color="#004EFF">
      <yd-tabbar-item title="首页" link="supplierIndex">
        <yd-icon name="home" slot="icon" size="0.54rem" color=""></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="我的预约" link="supplierList">
        <yd-icon name="checkoff" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="个人中心" link="#" active>
        <yd-icon name="ucenter-outline" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
    </yd-tabbar>
  </div>
</template>

<script>
import axios from 'axios'
var baseUrl = process.env.API_ROOT
export default {
  name: 'order',
  data() {
    return {
      openId: window.localStorage.getItem('openid'),
      userId: window.localStorage.getItem("checkUserId"),
      grantDateExpired: window.localStorage.getItem("grantDateExpired"),
      id: '',
      btns: [],
      userInfo:{},
      qrUrl: '',
      qrDigalogShow: false,
      applyNo:  0,
      unreadNum:0
    }
  },
  methods: {
    getUserInfo() {
      axios({
        method: 'get',
        url: baseUrl + 'suppplierUserInfo?userId=' + this.userId
      }).then(resp => {
        if (resp.data.error_code == '0') {
          this.userInfo = resp.data.data
        }
      })
    },
    myUnreadApprove(){
      axios({
        method: "get",
        url: baseUrl + "myUnreadApprove?userId="+this.userId
      }).then(resp => {
        if (resp.data.error_code == "0") {
          this.unreadNum = resp.data.data
        }
      })
    },
    myContract(){
      this.$router.push({ path: "/supplierMyContract"});
    },
    myApprove(){
      this.$router.push({ path: "/supplierMyApprove"});
    },
   updPsw(){
    this.$router.push({ path: "/supplierPsw"});
   },
    updateGrant(){
    this.$router.push({ path: "/updateGrant"});
   },
   logout(){
    window.localStorage.clear();
    this.$router.push({ path: "/login"});
   }
  },
  mounted() {
    this.getUserInfo()
    this.myUnreadApprove()
  }
}
</script>

<style scoped>
.line {
  border-bottom: 1px solid #000;
  background-color: black;
  height: 1px;
}
.yd-preview-header > :first-child {
  color: black;
  font-weight: bold;
  font-size: 16px;
  text-align: left;
}
.wrap /deep/ .yd-preview-footer:before {
  height: 2px;
}
.yd-preview {
  margin-bottom: 10px;
}
.yd-preview-footer {
  height: 0.8rem;
}
.wrap /deep/ .nobtn .yd-preview-footer {
  display: none;
}
.yd-badge-danger {
  background: rgba(47, 111, 255, 1) !important;
}
.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
.user-name {
  font-weight: bolder;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier-info.vue